import styles from "./StarRating.module.css";

// Read-only star rating. `value` is 0-5 (decimals allowed). The fill color
// uses the brand ember; empty stars are a soft grey. `count` shows
// "(165)" next to the stars when present.
export default function StarRating({ value = 0, count, size = "md" }) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  const pct = (v / 5) * 100;
  const cls = [styles.row, styles[size]].join(" ");
  return (
    <div className={cls} aria-label={`Rated ${v} out of 5${count != null ? `, ${count} reviews` : ""}`}>
      <div className={styles.stars} role="img">
        <div className={styles.empty}>★★★★★</div>
        <div className={styles.full} style={{ width: `${pct}%` }}>★★★★★</div>
      </div>
      {count != null && <span className={styles.count}>({count})</span>}
    </div>
  );
}
